<template>
  <div>
    <div class="main">
      <!-- <div><img src="../../../src/assets/nomenu.svg" /></div> -->
      <SvgIcon iconClass="nomenu_1" className="mymune" />
      <div style="margin-top: 16px">
        <span class="error_text">未配置应用菜单，请联系管理员</span>
      </div>
      <div
        style="margin-top: 10px; font-size: 15px; color: rgba(0, 0, 0, 0.65)"
      >
        <span class="text">{{ text }}</span>
      </div>
      <div style="margin-top: 41px">
        <el-button style="margin-left: 10px" @click="changeaccount"
          >切换账号</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import SvgIcon from "../../components/SvgIcon.vue";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      text: "点击下方返回登录按钮，返回登录页重新登录",
    };
  },
  methods: {
    changeaccount() {
      let param = { isSwitchAccount: 1 };
      this.$store.dispatch("ssologout", {
        param,
        cb: (data) => {
          data;
        },
      });
    },
  },
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.main {
  max-width: 1140px;
  // margin-right: auto;
  // margin-left: auto;
  padding: 217px 15px 0;
  margin: auto;
  text-align: center;
}
.contain {
  color: #155724;
  // background-color: #d4edda;
  border-color: #c3e6cb;
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.div_flex {
  display: flex;
  justify-content: space-around;
}
.error_text {
  color: #000000;
  opacity: 0.85;
  display: inline-block;
  font-size: 24px;
}
.text {
  color: #000000;
  opacity: 0.65;
  display: inline-block;
  font-size: 15px;
}
.mymune {
  height: 140px;
  width: 142px;
}
</style>